var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFont2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.4 500",
    style: {
      enableBackground: "new 0 0 330.4 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "159.3,46.2 82.2,464.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "176.0,56.8 185.764,99.594 195.582,134.076 261.23,318.198 332.9,482.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.4,341.6 39.789,336.106 55.463,333.204 71.316,331.162 87.235,330.167 123.17,330.655 214.909,335.672 238.863,335.806 254.788,335.034 274.627,332.883 306.095,327.508 310.1,326.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "97.6,20.4 122.1,468.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.6,58.3 102.263,45.229 126.123,42.408 138.011,41.616 145.936,41.505 153.884,41.863 161.798,42.7 169.657,44.011 177.417,45.825 185.037,48.152 192.489,50.97 199.765,54.224 210.362,59.765 220.545,66.045 227.058,70.641 233.319,75.567 239.304,80.826 244.982,86.422 250.298,92.362 255.19,98.654 259.585,105.305 263.394,112.305 266.527,119.633 267.817,123.405 268.915,127.238 269.814,131.122 270.504,135.047 270.977,139.004 271.219,142.985 271.217,146.971 270.957,150.947 270.422,154.896 269.598,158.797 268.474,162.621 267.053,166.343 265.338,169.942 263.337,173.388 261.058,176.658 258.513,179.724 255.716,182.563 252.684,185.149 249.438,187.461 246.004,189.478 242.41,191.197 238.689,192.64 234.894,193.833 227.143,195.639 215.32,197.394 147.759,203.106 131.945,205.217 124.11,206.651 116.34,208.516 108.763,210.986 105.098,212.537 101.586,214.371 98.271,216.618 95.427,219.364 93.417,222.791 92.883,226.712 93.912,230.549 95.891,233.989 98.389,237.092 101.187,239.932 104.188,242.578 110.524,247.4 120.584,253.877 159.114,274.799 172.681,283.171 185.757,292.293 198.343,302.078 207.379,309.913 213.07,315.494 218.371,321.446 223.148,327.825 225.292,331.184 227.249,334.656 229.014,338.23 230.586,341.893 233.165,349.433 235.011,357.188 236.149,365.075 236.605,373.033 236.398,381.002 235.537,388.926 234.027,396.752 231.865,404.423 229.048,411.88 225.572,419.052 221.46,425.869 216.774,432.302 211.571,438.337 205.909,443.96 199.847,449.157 193.448,453.91 186.737,458.212 179.749,462.045 172.514,465.391 165.067,468.235 157.445,470.564 149.687,472.384 137.885,474.305 118.042,476.071 98.153,476.912 86.191,476.71 74.282,475.77 62.473,474.151 46.838,471.109 27.528,466.221 23.6,465.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "257.3,36.9 245.982,32.769 234.474,29.348 226.697,27.566 218.83,26.277 210.907,25.591 202.93,25.629 198.959,25.962 194.987,26.527 191.077,27.328 187.233,28.369 183.461,29.647 179.77,31.151 172.643,34.748 165.9,39.022 159.57,43.892 153.629,49.23 85.846,116.968 75.075,128.762 67.469,138.034 60.386,147.706 53.932,157.786 48.207,168.293 43.281,179.212 39.116,190.443 35.636,201.906 31.93,217.442 29.231,233.184 27.906,245.09 27.215,257.049 27.195,269.028 27.899,280.986 29.392,292.872 30.859,300.723 32.725,308.488 34.993,316.145 37.661,323.672 40.722,331.049 44.168,338.253 47.988,345.266 54.376,355.399 61.449,365.067 69.1,374.284 77.24,383.074 85.823,391.445 94.838,399.342 104.276,406.705 114.143,413.487 124.396,419.681 138.525,427.129 156.699,435.387 179.015,444.095 201.737,451.709 217.125,455.979 228.83,458.525 240.645,460.455 252.546,461.717 260.538,462.021 268.492,461.83 276.443,461.159 288.267,459.357 300.024,456.737 315.31,452.313 326.7,448.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "87.4,68.5 126.984,409.819 129.248,441.493 129.447,449.538 129.337,453.665 128.789,457.402 126.214,457.658 124.778,453.956 122.862,446.225 75.682,130.249 72.728,102.467 71.997,90.46 71.951,82.503 72.152,78.547 72.575,74.586 73.284,70.656 74.319,66.81 75.672,63.064 77.32,59.412 79.234,55.904 81.4,52.553 83.802,49.371 86.427,46.37 89.258,43.564 92.282,40.964 95.484,38.583 98.849,36.434 102.357,34.53 105.991,32.882 109.731,31.487 113.554,30.341 117.443,29.435 121.377,28.765 125.343,28.319 129.328,28.091 133.321,28.072 141.283,28.635 149.153,29.957 156.878,31.968 164.421,34.58 171.762,37.715 178.894,41.302 185.814,45.284 195.796,51.895 205.309,59.167 214.372,66.993 225.812,78.121 236.555,89.927 246.571,102.37 255.805,115.395 266.327,132.353 279.63,156.922 286.506,171.332 291.124,182.381 295.132,193.664 298.445,205.16 301.096,216.83 303.677,232.602 304.94,244.51 305.567,256.468 305.436,268.441 304.864,276.403 303.86,284.323 302.42,292.175 299.524,303.792 295.857,315.191 291.546,326.363 286.67,337.3 281.207,347.955 275.117,358.265 268.366,368.154 260.92,377.561 252.826,386.38 247.079,391.905 241.056,397.128 234.758,402.032 228.189,406.57 221.366,410.704 214.307,414.424 207.049,417.74 195.871,422.014 188.246,424.34 180.541,426.068 168.663,427.852 141.022,430.009 17.0,431.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "304.7,23.1 284.887,23.551 265.21,25.161 241.594,28.623 202.933,36.86 92.433,68.528 35.2,87.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.6,87.0 152.2,476.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.2,295.2 297.9,235.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.0,476.9 328.5,471.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "148.3,33.5 168.7,482.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.5,288.4 206.514,262.267 280.444,249.54 362.9,239.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.7,79.8 178.166,37.131 205.545,31.234 244.963,25.498 264.851,23.619 316.781,22.533 336.746,23.154 364.571,25.609 388.4,28.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "307.1,79.7 301.852,68.835 297.946,61.895 293.603,55.192 288.752,48.827 286.144,45.848 283.332,42.956 280.406,40.276 277.312,37.781 274.016,35.481 270.579,33.447 267.001,31.693 263.294,30.233 259.478,29.076 255.58,28.217 251.628,27.64 247.645,27.324 243.649,27.271 239.659,27.485 235.693,27.963 231.766,28.695 227.892,29.665 224.078,30.851 216.648,33.779 209.467,37.281 199.057,43.217 185.698,51.983 153.754,75.982 132.216,93.805 114.546,110.024 97.818,127.165 84.692,142.238 74.877,154.834 65.763,167.963 57.465,181.628 51.851,192.21 46.813,203.072 42.388,214.204 38.591,225.566 35.424,237.129 32.896,248.837 30.445,264.608 28.541,284.514 27.583,304.471 27.671,320.449 28.468,332.406 30.053,344.284 31.589,352.125 33.526,359.876 35.876,367.512 38.656,375.002 41.876,382.314 45.545,389.411 49.665,396.256 54.236,402.809 59.259,409.02 64.732,414.84 70.659,420.219 77.002,425.096 83.712,429.42 90.755,433.158 98.099,436.276 105.7,438.737 113.483,440.534 121.381,441.746 129.337,442.466 141.316,442.826 157.295,442.371 173.229,441.014 185.082,439.302 196.812,436.908 208.363,433.789 219.719,429.974 230.85,425.504 241.72,420.427 255.766,412.87 282.933,395.988 296.117,386.958 305.659,379.706 314.721,371.866 320.402,366.249 325.745,360.309 330.71,354.05 335.255,347.48 339.335,340.611 342.903,333.464 345.912,326.064 348.305,318.441 350.012,310.638 350.584,306.685 350.956,302.707 351.117,298.715 351.058,294.721 350.769,290.736 350.248,286.775 349.495,282.851 348.509,278.979 347.287,275.175 345.828,271.457 344.128,267.842 342.184,264.352 339.994,261.01 337.559,257.844 334.881,254.881 331.969,252.147 328.852,249.65 325.563,247.385 322.131,245.339 318.582,243.5 311.23,240.383 303.634,237.909 295.883,235.964 284.088,233.85 272.178,232.522 252.228,231.554 228.26,231.68 212.306,232.593 196.416,234.348 184.609,236.406 180.707,237.343 176.884,238.525 173.337,240.288 173.309,243.57 176.811,245.516 180.585,246.801 184.447,247.783 192.323,249.181 200.278,250.005 248.2,251.211 264.134,252.415 276.006,254.045 283.849,255.564 291.606,257.484 299.234,259.86 306.681,262.751 313.878,266.218 320.734,270.316 324.001,272.614 327.143,275.081 333.033,280.477 338.393,286.399 343.233,292.756 347.566,299.467 351.411,306.472 354.776,313.716 357.661,321.167 360.067,328.785 361.998,336.537 363.468,344.389 364.493,352.312 365.081,360.28 365.238,368.266 364.724,380.231 363.443,392.144 360.799,407.904 357.199,423.473 350.426,446.399 337.0,484.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "157.3,17.7 143.8,482.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "345.5,22.2 352.049,129.951 352.303,169.886 347.491,265.728 344.162,301.489 338.525,336.87 309.7,469.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.2,238.0 418.9,215.001 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "201.2,67.6 201.2,486.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.8,67.6 196.035,34.218 231.656,28.997 247.349,27.508 255.435,27.221 259.288,27.305 263.305,27.654 267.233,28.446 270.82,29.996 273.645,32.682 275.374,36.218 275.808,40.112 275.313,44.095 274.312,47.954 271.526,55.469 266.44,66.364 247.14,100.929 174.4,216.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.4,481.2 278.7,481.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "107.6,43.5 356.1,39.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "231.9,18.8 263.529,121.669 273.032,160.324 284.131,219.038 287.991,246.652 290.375,274.44 291.172,302.312 289.953,342.134 286.362,385.812 284.355,401.622 282.217,413.381 280.326,421.122 277.957,428.729 275.029,436.138 271.49,443.277 269.476,446.716 267.292,450.049 264.931,453.258 262.389,456.324 259.66,459.227 256.743,461.942 253.642,464.441 250.362,466.701 246.915,468.701 243.327,470.426 239.617,471.869 235.806,473.029 231.92,473.906 227.98,474.51 224.007,474.851 220.021,474.943 216.041,474.802 212.072,474.444 208.127,473.886 204.232,473.125 200.443,472.111 196.739,470.841 189.472,467.683 178.777,461.948 152.213,445.027 20.4,347.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "84.1,18.6 96.6,481.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "272.3,47.7 84.771,221.475 67.767,238.501 62.352,244.414 57.427,250.505 55.225,253.829 53.391,257.343 51.915,261.063 50.859,264.917 50.292,268.863 50.264,272.849 50.787,276.803 51.831,280.652 53.336,284.354 55.221,287.873 57.409,291.204 59.844,294.364 62.45,297.339 65.222,300.121 71.264,305.268 315.4,464.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "54.1,23.8 30.3,476.201 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.2,459.8 83.282,445.451 109.853,437.701 136.771,431.467 152.379,428.797 171.897,426.704 238.951,424.239 266.9,424.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "60.3,145.8 58.962,293.847 57.43,321.601 48.773,401.041 48.019,412.978 47.885,420.996 48.207,428.962 48.623,432.955 49.317,436.888 50.554,440.654 53.577,442.225 55.805,438.934 57.255,435.259 60.602,423.708 91.211,274.943 97.444,235.511 110.973,120.419 114.264,100.716 117.789,85.129 119.968,77.441 122.55,69.877 125.652,62.513 127.436,58.939 129.396,55.459 131.55,52.091 133.906,48.864 136.467,45.798 139.226,42.909 142.177,40.213 145.307,37.73 148.607,35.479 152.067,33.48 155.671,31.754 159.401,30.325 163.238,29.212 167.156,28.434 171.127,27.999 175.123,27.9 179.111,28.127 183.069,28.673 186.972,29.53 190.796,30.69 194.516,32.147 198.109,33.894 201.55,35.926 204.812,38.232 207.874,40.796 210.735,43.584 213.402,46.562 215.882,49.695 220.342,56.321 224.236,63.301 227.671,70.518 232.158,81.632 235.975,92.995 240.172,108.416 243.527,124.04 246.074,139.811 248.506,163.639 250.813,219.562 250.587,259.535 248.895,287.43 245.542,323.257 245.294,331.255 245.576,335.244 247.196,338.707 250.223,336.56 252.078,333.041 253.55,329.31 255.902,321.682 258.656,309.959 278.67,171.525 284.085,144.118 287.925,128.603 291.397,117.129 294.107,109.612 297.207,102.247 300.764,95.088 304.875,88.236 307.176,84.975 309.675,81.849 312.384,78.91 315.321,76.208 318.509,73.8 321.946,71.765 325.61,70.182 329.45,69.081 333.396,68.463 337.388,68.315 341.371,68.623 345.296,69.372 349.114,70.546 352.781,72.13 356.254,74.108 359.481,76.458 362.435,79.146 365.12,82.109 367.545,85.278 369.742,88.615 371.734,92.081 375.2,99.282 378.117,106.722 381.759,118.143 385.589,133.658 389.746,157.267 395.47,208.888 397.24,236.801 396.868,304.72 384.8,480.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "60.8,75.1 39.23,401.727 38.63,421.759 38.888,429.81 39.528,433.618 41.339,437.06 44.799,436.345 47.081,433.087 48.799,429.489 51.482,421.981 54.555,410.381 59.698,382.914 72.803,275.903 84.959,96.665 86.278,84.804 87.657,76.953 88.655,73.076 90.003,69.309 91.87,65.808 94.481,62.816 97.969,60.933 101.93,60.915 105.537,62.46 108.721,64.884 111.509,67.739 113.995,70.822 116.276,74.069 120.414,80.93 125.789,91.583 135.089,113.768 163.27,196.931 180.271,254.357 189.402,293.144 210.985,398.777 215.881,418.121 219.479,429.58 222.456,436.971 224.271,440.531 226.43,443.865 229.135,446.787 232.55,448.777 236.476,449.239 240.348,448.315 243.928,446.554 247.224,444.314 250.301,441.769 253.205,439.011 258.567,433.108 263.496,426.823 270.23,416.924 278.29,403.145 308.26,342.282 317.782,320.325 325.964,297.828 349.713,213.281 378.0,76.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "286.5,140.9 275.453,136.024 267.971,133.289 260.308,131.026 252.477,129.342 244.528,128.359 240.584,128.167 236.551,128.188 232.558,128.431 228.608,128.895 224.675,129.581 216.915,131.564 209.363,134.174 190.905,141.828 172.92,150.571 152.002,162.315 131.733,175.169 115.455,186.779 99.823,199.233 84.881,212.525 73.522,223.788 65.473,232.684 57.943,242.024 51.051,251.842 46.86,258.655 43.031,265.677 39.596,272.9 36.593,280.313 34.056,287.908 32.006,295.648 30.444,303.492 29.369,311.412 28.777,319.379 28.665,327.372 29.03,335.361 29.861,343.316 31.145,351.21 32.867,359.021 35.014,366.726 37.574,374.309 40.555,381.749 43.973,388.993 47.846,395.989 52.19,402.687 57.022,409.036 62.353,414.996 68.117,420.541 74.25,425.675 80.695,430.411 87.406,434.763 94.342,438.746 105.099,444.056 116.193,448.62 127.541,452.513 142.952,456.795 158.604,460.092 174.436,462.375 186.391,463.386 194.386,463.649 202.382,463.492 210.353,462.832 218.251,461.578 226.01,459.647 233.573,457.051 240.932,453.918 251.633,448.493 272.306,436.313 282.338,429.732 288.807,425.027 295.021,419.993 300.901,414.572 306.379,408.746 311.46,402.569 316.167,396.102 322.588,385.969 328.335,375.438 335.097,360.943 340.978,346.067 347.344,327.106 351.577,311.668 354.05,299.939 355.776,288.075 356.748,276.117 357.144,256.126 356.116,224.136 354.394,204.229 352.121,188.398 348.974,172.711 344.938,157.234 340.005,142.017 334.21,127.108 327.591,112.545 322.058,101.9 315.88,91.617 311.324,85.043 306.374,78.762 301.004,72.836 295.245,67.286 289.157,62.099 282.79,57.259 272.81,50.6 262.418,44.612 251.643,39.347 240.516,34.862 229.12,31.124 217.536,28.066 209.687,26.504 201.779,25.427 193.78,24.834 185.824,24.692 173.785,25.209 161.935,26.431 146.116,28.938 138.2,30.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "90.0,78.5 121.8,487.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "77.2,161.3 69.519,122.133 67.196,106.395 66.06,94.485 65.767,86.546 65.981,78.59 66.818,70.662 67.515,66.735 68.425,62.852 69.571,59.037 70.977,55.315 72.667,51.71 74.663,48.257 76.968,45.012 79.585,42.01 82.498,39.292 85.673,36.885 89.067,34.801 92.643,33.043 96.362,31.611 100.188,30.501 104.094,29.709 108.05,29.228 112.03,29.055 116.014,29.184 119.976,29.607 123.898,30.304 127.771,31.245 131.586,32.405 139.014,35.281 146.181,38.77 153.09,42.744 159.757,47.111 166.172,51.84 172.307,56.926 178.134,62.364 183.621,68.143 188.736,74.254 193.468,80.668 199.903,90.74 205.651,101.223 212.459,115.635 218.415,130.419 223.463,145.538 226.604,157.072 229.085,168.767 230.284,176.646 231.047,184.579 231.307,192.544 230.992,200.507 230.033,208.418 228.358,216.207 227.229,220.029 225.895,223.784 224.351,227.457 222.592,231.032 220.618,234.493 218.438,237.829 213.564,244.131 208.146,249.975 202.326,255.421 193.077,262.995 183.408,270.025 173.357,276.498 162.92,282.325 152.1,287.405 144.678,290.301 137.088,292.722 129.349,294.628 121.495,296.007 113.575,296.879 105.617,297.284 97.669,297.228 89.731,296.722 77.886,295.248 62.2,292.274 35.206,285.359 27.5,283.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "229.2,30.0 199.122,40.971 180.785,48.728 166.399,55.671 142.068,69.377 121.826,82.17 108.809,91.413 96.307,101.346 84.412,112.0 75.952,120.478 67.944,129.384 60.458,138.732 53.584,148.539 47.422,158.807 43.76,165.902 38.958,176.873 34.971,188.165 31.774,199.707 29.348,211.408 27.662,223.251 26.703,235.201 26.46,247.204 26.908,259.151 28.88,279.006 34.62,314.51 39.653,337.922 44.878,357.187 49.918,372.34 54.298,383.487 59.266,394.409 64.829,405.013 70.997,415.259 77.785,425.121 85.203,434.533 90.517,440.503 96.135,446.177 102.063,451.512 108.315,456.468 114.889,461.0 121.755,465.074 128.888,468.661 136.258,471.731 143.834,474.25 151.58,476.185 159.45,477.516 167.401,478.254 175.386,478.413 183.362,478.003 191.283,477.038 199.116,475.529 206.825,473.51 214.405,471.024 221.845,468.112 232.72,463.039 243.206,457.254 253.302,450.811 262.972,443.746 272.184,436.094 280.905,427.892 289.085,419.133 296.629,409.826 301.253,403.327 305.529,396.583 311.319,386.1 319.743,368.006 331.673,338.358 336.836,323.258 341.1,307.879 344.405,292.256 347.424,272.524 349.4,252.634 349.998,236.691 349.695,224.732 348.661,212.827 346.947,200.973 343.735,185.308 339.616,169.86 334.637,154.686 328.771,139.852 321.993,125.414 314.308,111.422 305.729,97.927 298.732,88.207 291.173,78.917 285.774,73.033 280.059,67.459 274.004,62.256 267.607,57.483 260.904,53.147 253.95,49.215 243.196,43.957 228.467,37.8 217.215,33.77 205.744,30.387 190.128,26.829 170.505,23.645 146.6,21.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "170.4,299.4 225.927,377.35 245.577,402.545 255.83,414.477 264.159,423.085 270.069,428.368 279.534,435.562 292.749,444.446 320.264,460.448 327.334,464.124 330.966,465.714 334.653,467.088 338.451,468.266 346.171,470.028 354.032,471.137 361.95,471.733 373.872,471.911 389.896,471.183 417.461,468.252 441.3,464.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "80.5,46.3 68.163,330.01 64.889,370.198 63.364,382.106 61.824,389.794 60.496,393.385 57.467,395.539 54.782,392.825 53.37,389.053 52.426,385.202 51.15,377.303 50.052,365.371 49.272,329.358 50.565,233.307 49.712,209.364 42.227,133.783 41.384,117.811 41.318,105.816 41.901,93.834 42.737,85.881 44.034,77.99 45.902,70.213 48.462,62.641 50.04,58.968 51.837,55.395 53.862,51.947 56.116,48.644 58.589,45.503 61.271,42.537 64.154,39.764 67.225,37.203 70.475,34.875 73.892,32.799 77.464,31.001 81.172,29.505 84.995,28.337 88.907,27.515 92.875,27.035 96.871,26.879 100.868,27.03 104.841,27.464 108.777,28.164 112.663,29.109 116.487,30.284 120.238,31.671 123.908,33.257 127.49,35.033 134.373,39.102 140.863,43.773 146.956,48.95 152.662,54.554 157.991,60.517 162.954,66.788 167.538,73.341 171.712,80.161 175.44,87.236 178.681,94.546 181.394,102.068 183.539,109.771 185.084,117.617 185.996,125.56 186.237,133.553 185.767,141.535 184.545,149.435 182.551,157.178 181.264,160.964 179.784,164.679 178.111,168.31 176.246,171.847 174.189,175.277 171.945,178.586 169.514,181.761 166.903,184.789 164.121,187.66 161.183,190.371 154.911,195.331 148.217,199.704 141.2,203.538 133.936,206.885 126.485,209.79 111.23,214.588 80.368,223.023 72.775,225.527 65.348,228.523 61.765,230.297 58.334,232.334 55.127,234.739 52.35,237.601 50.295,241.011 49.269,244.86 49.312,248.837 50.213,252.745 51.698,256.428 53.598,259.945 55.788,263.297 60.733,269.574 66.172,275.425 77.882,286.343 158.736,351.727 209.718,396.595 243.521,430.478 295.0,486.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "348.5,84.5 330.131,68.972 314.281,56.942 304.34,50.241 294.055,44.136 283.327,38.744 272.279,34.15 260.928,30.325 253.208,28.273 245.388,26.656 237.491,25.48 225.552,24.487 213.572,24.298 201.601,24.806 185.704,26.397 169.92,28.862 154.287,32.155 138.848,36.267 127.442,39.938 119.971,42.768 112.66,45.99 105.577,49.679 98.803,53.911 92.444,58.745 89.458,61.397 86.627,64.214 83.972,67.201 81.526,70.36 79.324,73.688 77.4,77.189 75.8,80.848 74.566,84.645 73.732,88.549 73.297,92.518 73.241,96.512 73.544,100.495 74.182,104.436 75.135,108.315 76.382,112.111 77.906,115.802 79.691,119.375 81.725,122.813 83.993,126.102 86.467,129.236 91.91,135.078 97.836,140.437 107.268,147.825 140.187,170.448 228.88,224.459 252.152,240.001 268.154,251.907 283.385,264.801 306.41,286.974 322.823,304.449 335.753,319.653 347.864,335.527 361.306,355.369 369.56,369.049 377.035,383.168 381.973,394.084 384.866,401.533 387.313,409.137 389.145,416.911 389.763,420.86 390.136,424.836 390.225,428.825 389.99,432.813 389.391,436.762 388.412,440.632 387.066,444.392 385.369,448.008 383.339,451.447 380.995,454.681 378.357,457.679 375.445,460.412 372.282,462.849 368.893,464.962 365.309,466.722 361.574,468.133 357.734,469.223 353.82,470.027 349.862,470.581 341.894,471.068 333.905,470.918 321.968,469.882 306.167,467.517 181.527,439.237 139.179,427.621 19.1,383.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "14.8,54.4 224.854,45.056 260.308,41.933 287.766,37.966 307.178,34.024 333.967,26.938 364.3,17.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "213.9,17.4 202.3,482.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "331.9,18.0 345.289,113.033 347.862,140.732 349.413,192.6 348.731,232.542 347.054,256.438 344.48,276.22 337.021,315.452 332.258,334.818 327.524,350.07 321.873,365.007 315.295,379.559 309.733,390.166 303.539,400.419 299.007,406.993 294.117,413.305 288.845,419.302 283.179,424.928 277.126,430.135 270.695,434.868 263.905,439.067 256.779,442.667 249.356,445.606 241.694,447.851 233.858,449.379 225.914,450.166 217.93,450.188 213.947,449.903 206.051,448.734 198.296,446.837 190.717,444.327 183.32,441.318 172.549,436.079 162.114,430.194 152.054,423.694 142.467,416.523 136.387,411.342 130.605,405.836 122.494,397.024 114.992,387.686 105.784,374.639 97.305,361.095 89.56,347.14 82.582,332.773 76.424,318.057 71.107,302.988 66.686,287.634 62.371,268.144 56.755,232.658 54.299,208.83 53.216,184.949 57.5,61.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "30.3,64.7 116.5,469.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "267.2,91.4 106.8,469.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "40.2,28.1 70.512,317.307 74.125,340.715 79.781,367.979 83.768,383.387 87.394,394.762 91.647,405.912 98.198,420.419 105.602,434.522 111.688,444.799 116.153,451.39 121.098,457.623 123.8,460.55 126.676,463.302 129.74,465.838 133.004,468.113 136.463,470.082 140.086,471.727 143.84,473.047 147.693,474.041 151.616,474.714 155.58,475.075 159.559,475.132 163.532,474.896 167.479,474.376 171.379,473.581 175.214,472.522 178.975,471.219 182.651,469.689 186.234,467.955 193.104,463.942 199.575,459.304 205.636,454.146 211.293,448.546 216.553,442.571 221.433,436.283 225.955,429.732 232.112,419.501 237.582,408.888 243.975,394.308 253.479,368.122 258.081,352.884 260.859,341.277 262.96,329.523 264.74,313.725 266.4,238.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "386.8,18.6 416.528,97.013 425.223,123.492 430.406,142.636 437.222,173.776 440.449,193.435 442.103,209.283 443.206,233.171 442.832,273.033 441.074,304.88 439.439,320.741 437.619,332.559 435.136,344.256 431.977,355.789 426.868,370.892 419.324,389.338 412.386,403.693 406.519,414.112 399.97,424.118 395.156,430.472 389.864,436.437 386.995,439.209 383.957,441.787 380.731,444.118 377.29,446.141 373.652,447.759 369.832,448.881 365.889,449.442 361.903,449.46 357.951,448.987 354.069,448.079 350.294,446.792 346.653,445.18 343.148,443.279 339.791,441.124 336.593,438.745 333.559,436.161 330.689,433.395 327.978,430.471 322.998,424.248 318.531,417.647 312.587,407.269 305.654,392.912 299.565,378.176 293.027,359.35 287.568,340.187 279.095,301.261 266.4,218.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "32.9,36.0 160.212,183.636 235.39,281.012 350.1,443.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "304.8,18.4 45.5,481.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "299.2,68.9 257.928,193.624 233.754,256.833 216.096,296.878 194.312,339.278 174.341,373.724 156.987,400.357 133.578,432.508 90.3,484.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19.2,15.5 219.2,293.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z.2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "28.9,21.2 173.666,51.558 212.604,61.488 227.694,66.132 238.98,70.241 328.83,113.662 342.935,121.221 349.769,125.356 356.269,129.977 359.319,132.558 362.17,135.362 364.754,138.403 367.025,141.687 368.955,145.187 370.527,148.86 371.733,152.669 372.563,156.578 373.009,160.548 373.064,164.543 372.72,168.524 371.973,172.449 370.819,176.27 369.235,179.922 367.176,183.347 364.702,186.503 361.935,189.386 358.983,192.031 352.68,196.848 342.587,203.365 321.615,214.944 85.142,322.834 74.538,328.328 67.681,332.419 64.396,334.666 61.243,337.091 58.237,339.71 55.384,342.511 52.705,345.477 50.217,348.603 47.94,351.886 45.897,355.324 44.121,358.904 42.647,362.613 41.509,366.447 40.755,370.37 40.424,374.349 40.544,378.342 41.098,382.299 42.052,386.177 43.371,389.948 45.019,393.59 46.959,397.082 49.161,400.415 51.602,403.581 54.255,406.572 57.099,409.376 60.115,411.996 63.276,414.442 69.935,418.86 76.917,422.746 87.777,427.828 102.636,433.683 114.041,437.342 129.546,441.184 157.066,446.067 244.463,456.045 288.169,459.127 500.1,460.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont2);
export default __webpack_public_path__ + "static/media/font2.40c26cf7b56ab8753903fd90b181ea1d.svg";
export { ForwardRef as ReactComponent };